import React from 'react';
import type { MenuProps } from 'antd';
import { Dropdown, Space, Typography } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { CaretDownOutlined } from '@ant-design/icons';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

interface AuthHeaderProps {
    showLogoutLoading: () => void
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ showLogoutLoading }) => {

    const navigate = useNavigate();
    const auth = useAuth();
    const [userName, setUserName] = React.useState<string | undefined>();

    React.useEffect(() => {
        if (auth && auth.user) {
            setUserName(auth?.user.email)
        }
    }, [auth]);

    const items: MenuProps['items'] = [
        {
            label: 'Sign out',
            key: '1',
            onClick: async () => {
                showLogoutLoading()
                await auth?.signout(() => {
                    // window.location.href = "/";
                    return navigate('/', { replace: false });
                });
            }
        },
    ];

    return (
        <Header className='header' style={{ display: 'flex', alignItems: 'center', paddingLeft: 5, paddingRight: 25, justifyContent: 'space-between', background: '#ffffff' }}>
            <div></div>
            <Dropdown menu={{ items }}>
                <Space>
                    <Typography.Text>{userName}</Typography.Text>
                    <CaretDownOutlined />
                </Space>
            </Dropdown>

        </Header>
    );
}

export default AuthHeader;